import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '../components/ui/breadcrumb';
import { SemanticLayerViewToggle, type SemanticLayerViewMode } from '../components/ViewModeToggle';
import { SidebarTrigger } from '../components/ui/sidebar';

export default function SemanticLayer() {
  const navigate = useNavigate();
  const location = useLocation();

  const viewMode: SemanticLayerViewMode = location.pathname.includes('/diagram') ? 'diagram' : 'glossary';
  const subPageLabel = viewMode === 'diagram' ? 'Diagram' : 'Glossary';

  const handleViewModeChange = (mode: SemanticLayerViewMode) => {
    navigate(`/semantic-layer/${mode}`);
  };

  return (
    <div className="w-full flex flex-col bg-background overflow-hidden" style={{ height: 'calc(100vh)' }}>
      {/* Top Bar */}
      <div className="flex flex-col md:flex-row md:items-center justify-between w-full px-4 md:px-6 py-3 md:py-4 border-b border-border bg-background flex-shrink-0 z-10 gap-3">
        <div className="flex items-start gap-2 min-w-0">
          <SidebarTrigger className="md:hidden h-5 w-5" />
          <div className="flex flex-col gap-1 md:gap-2 min-w-0">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href="/semantic-layer">Semantic Layer</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>{subPageLabel}</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
          <h1 className="text-lg md:text-xl font-semibold text-foreground">Semantic Layer {subPageLabel}</h1>
          </div>
        </div>
        <div className="flex items-center">
          <SemanticLayerViewToggle value={viewMode} onChange={handleViewModeChange} />
        </div>
      </div>
      {/* Content */}
      <div className="flex-1 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
}
